import cn from 'clsx'

import './Overlay.css'

const Overlay = ({
    className,
    open,
    children,
    opacity = '0.4',
    ...props
}) => {
    
    if (!open) return null
    
    return (
        
        <div
            className={cn('Overlay', className)}
            style={{
                '--opacity': opacity,
            }}
            {...props}>
            
            {children}
        
        </div>
        
    )
    
}

export default Overlay
